/* ── Empty State ────────────────────────────────────────── */
export const EmptyState = ({ message = "No data found" }) => (
  <div className="st-empty-state">{message}</div>
);
